import { componentsTranslationKeys, dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { visitTranslationKeys } from '../../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../../visit/visit.draft';
import { getMedicalCertificateDraftToken } from '../medicalCertificate.draft';
import { medicalCertificateTranslationKeys } from '../translations';

import { MedicalCertificateFormController } from './MedicalCertificateForm.hooks';

type MedicalCertificateFormLeavingGuardProps = Pick<
   MedicalCertificateFormController,
   'handleSubmitDraft' | 'formState'
> & {
   readonly visitId: number;
};

export const MedicalCertificateFormLeavingGuard = (props: MedicalCertificateFormLeavingGuardProps): JSX.Element => {
   const { executeAsync: saveMedicalCertificateDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });

   return (
      <RouteLeavingGuard
         testId={'formLeavingConfirmation'}
         title={componentsTranslationKeys.leaveForm}
         message={componentsTranslationKeys.formLeavingConfirmation}
         successMessage={medicalCertificateTranslationKeys.form.leavingGuard.successMessage}
         onLeave={props.handleSubmitDraft(async (formValues) => {
            await saveMedicalCertificateDraft({
               token: getMedicalCertificateDraftToken(props.visitId),
               tags: [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
               contents: formValues,
            });
         })}
         active={props.formState.isDirty}
      />
   );
};
